"use strict";
export const MINT_INPUT_STABLES = ["USDT", "USDC", "DAI"];
export const RING_STABLE_MINTER_ABI = [
  "function usdr() view returns (address)",
  "function fwUsdr() view returns (address)",
  "function usdrDecimals() view returns (uint8)",
  "function fwUsdrDecimals() view returns (uint8)",
  "function isStableSupported(address stable) view returns (bool)",
  "function fwTokenOf(address stable) view returns (address)",
  "function stableConfigs(address stable) view returns (address fwToken, uint8 decimals, uint8 fwDecimals, bool supported, uint256 debt)",
  "function quoteMint(address stable, uint256 amountIn) view returns (uint256 amountIn, uint256 amountOut, uint256 pricePer18)",
  "function mint(address stable, uint256 amountIn, uint256 minAmountOut, address recipient) returns (uint256)"
];
export const ERC20_APPROVAL_ABI = [
  "function allowance(address owner, address spender) view returns (uint256)",
  "function approve(address spender, uint256 amount) returns (bool)"
];
